import { useQuery } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

export type CompanyResponse = {
  company: {
    name: string
    contactNumber: string
    emailAddress: string
    feeMultiplier: number
    websiteUrl: string
    address: {
      streetNumberAndName: string
      apartmentNumber: string
      city: string
      zipCode: string
      state: string
      country: string
    }
  }
  transfers: [
    {
      externalTransferId: string
      status: string
      amount: {
        value: number
        currencyCode: {
          value: string
          displayName: string
          cultureName: string
        }
      }
      date: string
      senderName: string
      recipientName: string
      senderAccount: string
      recipientAccount: string
      isRefunded: true
      isReimbursed: true
      appliedForReimbursement: true
      recipientAddress: {
        streetNumberAndName: string
        apartmentNumber: string
        city: string
        zipCode: string
        state: string
        country: string
      }
    }
  ]
}

export function useCompany(companyId?: string) {
  return useQuery<CompanyResponse>({
    queryKey: ["company", companyId],
    queryFn: async () => {
      const response = await fetcher(
        `/Company/${companyId}`,
        {
          method: "GET",
        },
        {
          useAccessToken: true,
        }
      )
      const responseJson = await response.json()

      return responseJson
    },
    enabled: !!companyId,
  })
}
